import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks";

import type { ShareboxLog } from "models";

const component = "ShareboxDashboard";

type ShareboxListResponse = {
  items: ShareboxLog[];
  nb_pages: number;
};

export const ShareboxDashboardQueryKeys = {
  list: backendQueryKey<ShareboxListResponse>({ component, baseUrl: ENV.shareboxBaseURL, endpoint: "/logs/list" }),
  filters: localQueryKey<number>({ component, data: "filters" })
};
